// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"0f6a2a09","379":"c4842648"}[chunkId] + ".chunk.css";
};